import "./module/userAgentChecker.js"
import "./module/plugin.js"
import "./module/modal-multi.js"

import ModalVideo from 'modal-video'
new ModalVideo('.js-modal-video', {
    youtube:{
        autoplay: 1,
        controls: 1,
        nocookie: true,
        mute:1,
        loop:1,
        showinfo:1
    }
});

import Swiper from 'swiper/bundle'
var myswiper01 = new Swiper('.lab-slider', {
    slidesPerView: 'auto',
    spaceBetween: 30,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

var myswiper02 = new Swiper('.mv__slider', {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 100,
    loop: true,
    speed: 1350,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

import $ from 'jquery';
import "./module/jquery.cookie.js";
//cookieの値がonじゃなかったら表示させる
/*if ($.cookie('bnrRead') != 'on') {
    $('#movieLoading').addClass("appear");
}
//隠すボタンをクリックしたらバナーを隠す
$('#btn').click(function() {
    $('#movieLoading').remove();
    $.cookie('bnrRead', 'on', { //cookieにbnrReadという名前でonという値をセット
        expires: 1, //cookieの有効日数
        path:'/' //有効にするパス
    });
});*/

var cookie = $.cookie('loading');
if(cookie){
    $('#loading').addClass("close");
    $('#loading').remove();
}
$('#btn').on('click',function(){
    $('#loading').addClass("close");
    $('#loading').remove();
    $.cookie('loading','close', { //cookieにbnrReadという名前でonという値をセット
        expires: 1, //cookieの有効日数
        path:'/' //有効にするパス
    });
});

import ScrollMagic from "scrollmagic";
var controller = new ScrollMagic.Controller();

/*new ScrollMagic.Scene({triggerElement: "#lv__MS", triggerHook: 'onCenter', duration: $('#lv__MS').height()})
.setClassToggle("#ico__MS", "active") // add class toggle
.addTo(controller);
new ScrollMagic.Scene({triggerElement: "#lv__FI", triggerHook: 'onCenter', duration: $('#lv__FI').height()})
.setClassToggle("#ico__FI", "active") // add class toggle
.addTo(controller);
new ScrollMagic.Scene({triggerElement: "#lv__RO", triggerHook: 'onCenter', duration: $('#lv__RO.is-open').height()})
.setClassToggle("#ico__RO", "active") // add class toggle
.addTo(controller);
new ScrollMagic.Scene({triggerElement: "#lv__AE", triggerHook: 'onCenter', duration: $('#lv__AE.is-open').height()})
.setClassToggle("#ico__AE", "active") // add class toggle
.addTo(controller);
new ScrollMagic.Scene({triggerElement: "#lv__QU", triggerHook: 'onCenter', duration: $('#lv__QU.is-open').height()})
.setClassToggle("#ico__QU", "active") // add class toggle
.addTo(controller);
new ScrollMagic.Scene({triggerElement: "#lv__EN", triggerHook: 'onCenter', duration: $('#lv__EN.is-open').height()})
.setClassToggle("#ico__EN", "active") // add class toggle
.addTo(controller);
new ScrollMagic.Scene({triggerElement: "#lv__ME", triggerHook: 'onCenter', duration: $('#lv__ME.is-open').height()})
.setClassToggle("#ico__ME", "active") // add class toggle
.addTo(controller);*/

$('#lv__MS .course__innerBlockTtl').on("click", function() {
    //MS
    if($(this).parent('#lv__MS').hasClass('is-open')){
        $(this).parent('#lv__MS').removeClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__MS", triggerHook: 'onLeave', duration: $(this).parent('#lv__MS').height()})
        .setClassToggle("#ico__MS", "active") // add class toggle
        .addTo(controller);
    } else {
        $(this).parent('#lv__MS').addClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__MS", triggerHook: 'onLeave', duration: $(this).parent('#lv__MS.is-open').height()})
        .setClassToggle("#ico__MS", "active") // add class toggle
        .addTo(controller);
    }
});

$('#lv__FI .course__innerBlockTtl').on("click", function() {
    //FI
    if($(this).parent('#lv__FI').hasClass('is-open')){
        $(this).parent('#lv__FI').removeClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__FI", triggerHook: 'onLeave', duration: $('#lv__FI').height()})
            .setClassToggle("#ico__FI", "active") // add class toggle
            .addTo(controller);
    } else {
        $(this).parent('#lv__FI').addClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__FI", triggerHook: 'onLeave', duration: $('#lv__FI.is-open').height()})
            .setClassToggle("#ico__FI", "active") // add class toggle
            .addTo(controller);
    }
});

$('#lv__RO .course__innerBlockTtl').on("click", function() {
    //RO
    if($(this).parent('#lv__RO').hasClass('is-open')){
        $(this).parent('#lv__RO').removeClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__RO", triggerHook: 'onLeave', duration: $('#lv__RO').height()})
            .setClassToggle("#ico__RO", "active") // add class toggle
            .addTo(controller);
    } else {
        $(this).parent('#lv__RO').addClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__RO", triggerHook: 'onLeave', duration: $('#lv__RO.is-open').height()})
            .setClassToggle("#ico__RO", "active") // add class toggle
            .addTo(controller);
    }
});

$('#lv__AE .course__innerBlockTtl').on("click", function() {
    //AE
    if($(this).parent('#lv__AE').hasClass('is-open')){
        $(this).parent('#lv__AE').removeClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__AE", triggerHook: 'onLeave', duration: $('#lv__AE').height()})
            .setClassToggle("#ico__AE", "active") // add class toggle
            .addTo(controller);
    } else {
        $(this).parent('#lv__AE').addClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__AE", triggerHook: 'onLeave', duration: $('#lv__AE.is-open').height()})
            .setClassToggle("#ico__AE", "active") // add class toggle
            .addTo(controller);
    }
});

$('#lv__QU .course__innerBlockTtl').on("click", function() {
    //QU
    if($(this).parent('#lv__QU').hasClass('is-open')){
        $(this).parent('#lv__QU').removeClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__QU", triggerHook: 'onLeave', duration: $('#lv__QU').height()})
            .setClassToggle("#ico__QU", "active") // add class toggle
            .addTo(controller);
    } else {
        $(this).parent('#lv__QU').addClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__QU", triggerHook: 'onLeave', duration: $('#lv__QU.is-open').height()})
            .setClassToggle("#ico__QU", "active") // add class toggle
            .addTo(controller);
    }
});

$('#lv__EN .course__innerBlockTtl').on("click", function() {
    //EN
    if($(this).parent('#lv__EN').hasClass('is-open')){
        $(this).parent('#lv__EN').removeClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__EN", triggerHook: 'onLeave', duration: $('#lv__EN').height()})
            .setClassToggle("#ico__EN", "active") // add class toggle
            .addTo(controller);
    } else {
        $(this).parent('#lv__EN').addClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__EN", triggerHook: 'onLeave', duration: $('#lv__EN.is-open').height()})
            .setClassToggle("#ico__EN", "active") // add class toggle
            .addTo(controller);
    }
});

$('#lv__MB .course__innerBlockTtl').on("click", function() {
    //MB
    if($(this).parent('#lv__MB').hasClass('is-open')){
        $(this).parent('#lv__MB').removeClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__MB", triggerHook: 'onLeave', duration: $('#lv__MB').height()})
            .setClassToggle("#ico__MB", "active") // add class toggle
            .addTo(controller);
    } else {
        $(this).parent('#lv__MB').addClass('is-open');
        // build scenes
        new ScrollMagic.Scene({triggerElement: "#lv__MB", triggerHook: 'onLeave', duration: $('#lv__MB.is-open').height()})
            .setClassToggle("#ico__MB", "active") // add class toggle
            .addTo(controller);
    }
});

var citys = ['MS','FI','RO','AE','QU','EN','MB'];
 
// 条件式をcitys.lengthとすれば配列をカウントできる
for (var i=0; i<citys.length; i++) {
    if($('#lv__' + citys[i]).hasClass('is-open')){
        // build scenes
        new ScrollMagic.Scene({triggerElement: '#lv__' + citys[i], triggerHook: '0.3', duration: $('#lv__'  + citys[i] + '.is-open').height()})
            .setClassToggle('#ico__' + citys[i], 'active') // add class toggle
            .addTo(controller);
    } else {
        // build scenes
        new ScrollMagic.Scene({triggerElement: '#lv__'  + citys[i], triggerHook: '0.3', duration: $('#lv__'  + citys[i]).height()})
            .setClassToggle('#ico__' + citys[i], 'active') // add class toggle
            .addTo(controller);
    }
}

$('.side__navListItemLink').on("click", function() {
    $(this).parent('.side__navListItem').toggleClass('active');
});